import React from 'react';
import { Alert, Button, Space } from 'antd';
import { Link } from 'react-router-dom';

const resolveBannerConfig = (user) => {
  const accessState = String(user?.tenant_access_state || '').toLowerCase();
  const hasTenantContext = Boolean(user?.current_tenant_id);
  const isPlatformAdmin = user?.is_platform_admin === true;
  const accessAllowed = user?.tenant_access_allowed !== false;
  const shouldWarn = user?.tenant_should_warn === true;
  const warningReason = String(user?.tenant_warning_reason || '').trim();
  const daysUntilTrialEnd = Number.isFinite(user?.tenant_days_until_trial_end)
    ? user.tenant_days_until_trial_end
    : null;

  if (!hasTenantContext || isPlatformAdmin || !accessAllowed) {
    return null;
  }

  if (accessState === 'trialing') {
    const message =
      daysUntilTrialEnd !== null
        ? `Voce esta no periodo trial do FisiSaaS. Faltam ${daysUntilTrialEnd} dias para o termino.`
        : 'Voce esta no periodo trial do FisiSaaS.';

    return {
      type: 'info',
      message,
      description: 'Ao final do trial, sua assinatura pode entrar em periodo de regularizacao antes da suspensao.',
    };
  }

  if (accessState === 'grace') {
    return {
      type: 'warning',
      message: 'Seu periodo trial terminou. Voce esta no periodo de regularizacao.',
      description: 'Regularize sua assinatura para evitar suspensao.',
    };
  }

  if (accessState === 'active' && (shouldWarn || warningReason)) {
    return {
      type: 'info',
      message: 'Sua assinatura esta ativa, mas possui um aviso comercial.',
      description: warningReason || 'Acesse sua assinatura para revisar os detalhes do lifecycle.',
    };
  }

  return null;
};

const TenantLifecycleBanner = ({ user }) => {
  const banner = resolveBannerConfig(user);

  if (!banner) {
    return null;
  }

  return (
    <Alert
      showIcon
      type={banner.type}
      message={banner.message}
      description={
        <Space direction="vertical" size={8}>
          <span>{banner.description}</span>
          <Link to="/conta/assinatura">
            <Button size="small" type="default">Ver minha assinatura</Button>
          </Link>
        </Space>
      }
      style={{ marginBottom: 16 }}
    />
  );
};

export default TenantLifecycleBanner;
